export enum Variant {
    Toolbar = 'toolbar',
    Form = 'form',
    AgGrid = 'agGrid',
    SearchBar = 'searchBar',
}
